import React from 'react';
import * as filterHeaderTypes from '../../webcommon/header/filterheader/propTypes';
import ComponentWithTooltip from '../../webcommon/common/formcomponents/customvalidation/ComponentWithTooltip';
import { lastWorkingDay } from '../../common/helpermethods/HelperMethods';
import StyledCell from './customgridcomponents/StyledCell';

export const filterHeaderId = 'ImpactAnalysis';

export const filterDefinitions = [
    {
        id: 'runDate',
        title: 'EOD Date',
        type: filterHeaderTypes.filterTypes.date,
        defaultValue: { from: lastWorkingDay(), to: null, today: false },
        availableValues: undefined,
        availableValuesLocation: undefined,
        server: true,
        fromOnly: true,
        singleDay: true,
        hideAllButton: true,
        hideToday: true
    },
    {
        id: 'counterparty',
        title: 'Counterparty',
        type: filterHeaderTypes.filterTypes.radioList,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: 'api:SystemInfo/counterparties',
        server: true,
        wide: true,
        includeGroupTitle: false
    },
    {
        id: 'csa',
        title: 'CSA',
        type: filterHeaderTypes.filterTypes.radioList,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: 'api:SystemInfo/csas',
        server: true,
        includeGroupTitle: false
    }
];

export const defaultFilters = [
    {
        value: {
            from: lastWorkingDay(),
            to: null,
            today: false
        },
        definition: filterDefinitions.find(def => def.id === 'runDate')
    },
    {
        value: [],
        definition: filterDefinitions.find(def => def.id === 'csa')
    },
    {
        value: [],
        definition: filterDefinitions.find(def => def.id === 'counterparty')
    }
];

const StyledCellWithTooltip = ComponentWithTooltip(StyledCell);

export const summaryGridColumns = [
    {
        id: 'product',
        title: 'Product',
        renderCell: row => <StyledCell value={ row.value } />
    },
    {
        id: 'model',
        title: 'IM Model',
        renderCell: row => <StyledCell value={ row.value } />
    },
    {
        id: 'dealTypes',
        title: 'Deal Types',
        renderCell: row => (
            <StyledCellWithTooltip
                showTooltip
                placement="bottomLeft"
                tooltipMessage={ row.value.join(', ') }
                value={ row.value.join(', ') }
            />
        )
    }
];
